import { render } from "./ChatFeedbackReview.vue?vue&type=template&id=aeb57b58"
import script from "./ChatFeedbackReview.vue?vue&type=script&lang=js"
export * from "./ChatFeedbackReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__